import { z } from 'zod';

import env from '../../env';
import { createApi } from '../core';

export type StudentDetails = {
  sfid?: string;
  firstName: string;
  lastName: string;
  state: string | null;
  postcode: string | null;
  yearLevel: string;
};

export type SignUpForUnderagedChildParams = {
  leadId: string;
  countryCode: 'AU' | 'NZ';
  mobile: string;
  name: string;
  email: string;
  firstName: string;
  lastName: string;
};

export const clueyPlusApi = createApi.group(['clueyPlus'], () => {
  return {
    signUp: createApi.mutation({
      mutationFn: (params: { leadId: string; countryCode: 'AU' | 'NZ'; students: StudentDetails[] }) => {
        const isNZ = params.countryCode === 'NZ';
        return createApi.fetch({
          basePath: 'mulesoftCustomer',
          path: ['internal', 'events', 'signUp', 'trigger'],
          method: 'POST',
          body: {
            returnResult: false,
            userIdentifierField: {
              type: 'leadId',
              value: params.leadId,
            },
            event: {
              type: 'clueyPlus',
              sourceSystem: 'Hub',
            },
            data: {
              countryCode: params.countryCode,
              customerType: 'New',
              studentDetails: params.students,
              productSubscriptionId: isNZ
                ? env.REACT_APP_CLUEY_PLUS_PRODUCT_SUBSCRIPTION_ID_NZ
                : env.REACT_APP_CLUEY_PLUS_PRODUCT_SUBSCRIPTION_ID_AU,
            },
          },
          validator: z.unknown(),
          sign: true,
        });
      },
    }),
    signUpForUnderagedChild: createApi.mutation({
      mutationFn: (params: SignUpForUnderagedChildParams) => {
        const { countryCode, leadId, mobile, name, email, firstName, lastName } = params;
        return createApi.fetch({
          basePath: 'studentHubAPI',
          path: ['parent-sign-up'],
          method: 'POST',
          body: {
            dryRun: false,
            parentDetails: {
              name,
              email,
              mobile,
              countryCode,
              firstName,
              lastName,
            },
            studentDetails: {
              id: leadId,
            },
          },
          validator: z.unknown(),
          sign: true,
        });
      },
    }),
  };
});
